import React, { Component } from 'react';
import { appNavigation, urlMap } from '../../utils';
import Footer from '../components/Footer';

class Unsubscribe extends Component {
  state = {
    loading: false,
    submitting: false,
    success: false,
    message: '',
    token: '',
  };

  componentDidMount() {
    const params = new URLSearchParams(window.location.search || '');
    const token = String(params.get('token') || '').trim();

    if (!token) {
      this.setState({
        token: '',
        success: false,
        message: 'Invalid unsubscribe link. Missing token.',
      });
      return;
    }

    this.setState({ token, message: 'Click the button below to confirm unsubscribe.' });
  }

  unsubscribeFromToken = async () => {
    const token = String(this.state.token || '').trim();
    if (!token || this.state.submitting) return;

    this.setState({ submitting: true, loading: true, message: '' });

    try {
      const res = await fetch(urlMap.unsubscribeNewsletter, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      });

      if (!res.ok) {
        this.setState({
          submitting: false,
          loading: false,
          success: false,
          message: 'We could not process this unsubscribe link. It may be expired or invalid.',
        });
        return;
      }

      this.setState({
        submitting: false,
        loading: false,
        success: true,
        message: 'You have been unsubscribed from Storyclub newsletter emails.',
      });
    } catch {
      this.setState({
        submitting: false,
        loading: false,
        success: false,
        message: 'Network error while processing your unsubscribe request. Please try again later.',
      });
    }
  };

  render() {
    const { submitting, success, token } = this.state;
    const canSubmit = Boolean(token) && !submitting && !success;

    return (
      <div className="login-page">
        <div className="login-wrapper">
          <div className="login-form">
            <h2>Please confirm your new email preferences.</h2>

            {!success && (
              <button type="button" onClick={this.unsubscribeFromToken} disabled={!canSubmit}>
                {submitting ? 'Unsubscribing…' : 'Unsubscribe'}
              </button>
            )}

            <button
              type="button"
              className="secondary"
              onClick={() => (window.location.href = appNavigation.register)}
            >
              Create account
            </button>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

export default Unsubscribe;
